/**
 * @generated SignedSource<<6b0f2b576a603a9e7a5213f6f297e71c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MovedColumnsInProjectEvent$data = {
  readonly actor: {
    readonly " $fragmentSpreads": FragmentRefs<"EventActor" | "EventActorAvatarItemBadge">;
  } | null;
  readonly createdAt: string;
  readonly databaseId: number | null;
  readonly previousProjectColumnName: string;
  readonly project: {
    readonly name: string;
    readonly url: string;
  } | null;
  readonly projectColumnName: string;
  readonly " $fragmentType": "MovedColumnsInProjectEvent";
};
export type MovedColumnsInProjectEvent$key = {
  readonly " $data"?: MovedColumnsInProjectEvent$data;
  readonly " $fragmentSpreads": FragmentRefs<"MovedColumnsInProjectEvent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MovedColumnsInProjectEvent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventActor"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventActorAvatarItemBadge"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Project",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "previousProjectColumnName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectColumnName",
      "storageKey": null
    }
  ],
  "type": "MovedColumnsInProjectEvent",
  "abstractKey": null
};

(node as any).hash = "934fc760884a818bb27be79b6d36d518";

export default node;
